import { render, staticRenderFns } from "./AgendaIndex.vue?vue&type=template&id=f678f664&scoped=true"
import script from "./AgendaIndex.vue?vue&type=script&lang=js"
export * from "./AgendaIndex.vue?vue&type=script&lang=js"
import style0 from "./AgendaIndex.vue?vue&type=style&index=0&id=f678f664&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f678f664",
  null
  
)

export default component.exports